import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';

import {InlineMsgModule} from '../../shared/inline-msg/inline-msg.module';
import {AddressModule} from '../../shared/address/address.module';
import {StateSelectorModule} from '../../shared/state-selector/state-selector.module';

import {LegalInfoComponent} from './legal-info.component';

import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faSync} from '@fortawesome/free-solid-svg-icons';
import {faCheckCircle, faTimesCircle} from '@fortawesome/free-regular-svg-icons';

@NgModule({
    declarations: [
        LegalInfoComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        InlineMsgModule,
        AddressModule,
        FormsModule,
        StateSelectorModule,
        FontAwesomeModule
    ],
    exports: [ LegalInfoComponent ]
})

export class LegalInfoModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faSync, faTimesCircle, faCheckCircle);
  }
}
